import { faLongArrowDown, faLongArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import styles from 'components/UI/V3/Table/HeaderCell/TableHeaderCell.module.scss';
import React from 'react';
import { TableSortDirection } from 'utils/tableSort';

interface TableHeaderCellProps extends React.ComponentProps<'th'> {
    sortDirection?: TableSortDirection;
    onSort?: () => void;
}

export const TableHeaderCell: React.FC<TableHeaderCellProps> = ({
    children,
    className,
    sortDirection,
    onSort,
    onClick,
    ...props
}) => {
    const handleClick = (event: React.MouseEvent<HTMLTableHeaderCellElement>) => {
        onSort?.();
        onClick?.(event);
    };

    return (
        <th
            className={clsx(styles.root, onSort && styles.sortable, className)}
            onClick={onSort ? handleClick : onClick}
            {...props}
        >
            <span className={styles.content}>
                {children}
                {sortDirection && (
                    <FontAwesomeIcon
                        icon={sortDirection === 'asc' ? faLongArrowUp : faLongArrowDown}
                        className={styles.sortIcon}
                    />
                )}
            </span>
        </th>
    );
};
